export const SET_INDUSTRY_DATA = "SET_INDUSTRY_DATA";
export const INDUSTRY_FETCHING_INIT = "INDUSTRY_FETCHING_INIT";
export const INDUSTRY_FETCHING_COMPLETED = "INDUSTRY_FETCHING_COMPLETED";
